export default {
  baseUrl: process.env.VUE_APP_API_URL + "api/"
};
